/**
 * slider using slickjs
 * @link https://kenwheeler.github.io/slick/
 */

jQuery(document).ready(function () {

	jQuery('.js-article-slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		draggable: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		lazyLoad: 'ondemand',

		customPaging: function (slider, i) {
			return '<div class="p-0.5 cursor-pointer"><img class="tab lazyload" src="' + $(slider.$slides[i]).find('[data-src]').data('src') + '"></img></div>';
		},
	});

	/**
	 * Toggle click to trigger whole text on image on smaller screens
	 */

	jQuery('.js-text-image').on('click', function () {
		jQuery(this).toggleClass('no-truncate');
	});

	jQuery('.js-video-slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		draggable: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		lazyLoad: 'ondemand',

		customPaging: function (slider, i) {
			return '<div class="p-0.5 relative cursor-pointer" data-id="' + $(slider.$slides[i]).find('[data-id]').data('id') + '"><div class="hidden md:inline-flex z-30 items-center text-tuna hover:text-saffron absolute bottom-1 left-1 cursor-pointer"><span class="jam jam-play flex items-center justify-center rounded-full border border-whisper bg-white h-2 w-2 text-1 relative z-30"></span><span class="bg-white border border-whisper -ml-1 pl-1.5 pr-1 h-2 rounded-r-4 flex items-center font-sans text-0.75 text-tuna truncate">' + $(slider.$slides[i]).find('[data-duration]').data('duration') + ' min</span></div><img class="tab w-full lazyload" src="' + $(slider.$slides[i]).find('[data-src]').data('src') + '"></img></div>';
		},
	});

});
